import { useQuery } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';
import { Modal, Select } from 'antd';
import { useUpdateTodoMutation, UseTicketListParams } from 'hooks/business/chat/useTicketMutations';
import { useMemo, useState } from 'react';
import { queries } from 'services/queries';

interface TransferTicketModalProps {
  id: string;
  storeId: string;
  visible: boolean;
  operator?: string;
  listParams: UseTicketListParams | null;
  onCancel: () => void;
}

export const TransferTicketModal = (props: TransferTicketModalProps) => {
  const { id, storeId, operator, listParams, visible, onCancel } = props;
  const { t } = useTranslate();
  const updateTodoMutation = useUpdateTodoMutation(listParams);
  const [value, setValue] = useState<string | undefined>(operator);

  const { data } = useQuery({
    ...queries.tickets.assistants(storeId),
    enabled: visible,
  });

  const options = useMemo(() => {
    return (
      data?.data?.assistants?.map((assistant) => ({
        label: assistant.name,
        value: assistant.id,
      })) ?? []
    );
  }, [data]);

  return (
    <Modal
      width={460}
      title={t('transfer_todo')}
      visible={visible}
      onCancel={() => onCancel()}
      onOk={() => {
        if (!!value && value !== operator) {
          updateTodoMutation.mutate({ id, operator: value });
          onCancel();
          return;
        }
        onCancel();
      }}
      confirmLoading={updateTodoMutation.isLoading}
    >
      <div>{t('todo.受理客服')}</div>
      <Select
        placeholder={t('department.请选择x', { x: t('todo.受理客服') })}
        value={value === '0' ? undefined : value || undefined}
        onChange={setValue}
        options={options}
        style={{ width: '100%', marginTop: '6px' }}
      />
    </Modal>
  );
};
